import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';

export function ProfileOverviewHeaderTitle() {
  const { t } = useScopedTranslation();
  return (
    <Text variant="bodyXLargeMedium" color="white-label.header.on-header">
      {t('title')}
    </Text>
  );
}
